export const ffToBasicInput = (field) => ({
    state: field.state,
    onBlur: field.flush,
    hasError: field.error,
    domRef: field.domRef,
});
